import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/focus.vue
var o = {
	name: "DtIconFocus",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--focus"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Focus",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M6 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM4 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0ZM2.5 2a.5.5 0 0 0-.5.5v1a.5.5 0 0 1-1 0v-1A1.5 1.5 0 0 1 2.5 1h1a.5.5 0 0 1 0 1h-1ZM8 1.5a.5.5 0 0 1 .5-.5h1A1.5 1.5 0 0 1 11 2.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 1-.5-.5ZM10.5 8a.5.5 0 0 1 .5.5v1A1.5 1.5 0 0 1 9.5 11h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 1 .5-.5Zm-9 0a.5.5 0 0 1 .5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 1 0 1h-1A1.5 1.5 0 0 1 1 9.5v-1a.5.5 0 0 1 .5-.5Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=focus.js.map